import { render, staticRenderFns } from "./TessTitle.vue?vue&type=template&id=a44aa9ec&"
import script from "./TessTitle.vue?vue&type=script&lang=ts&"
export * from "./TessTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports